import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class KnowledgeArchivePageService {
	private getKbUrl = environment.baseApiUrl + 'kb/{idKb}';
	private evaluateKbUrl = environment.baseApiUrl + 'kb/{idKb}/evaluate';
	private postCommentaryKbUrl = environment.baseApiUrl + 'kb/{idKb}/evaluate';
	private putRequestSolvedByKbUrl = environment.baseApiUrl + 'knowSolutions';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getKb(idKb: string): Observable<kbArchiveInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getKbUrl = this.getKbUrl.replace('{idKb}', idKb);
		return this.http.get<JSON[]>(getKbUrl, { headers: headers }).pipe(
			map((kbRes: any) => {
				kbRes = kbRes[0];
				const newKb: kbArchiveInterface = {
					id: kbRes.id,
					registered_by: kbRes.registered_by,
					driver: kbRes.driver,
					problem_manager: kbRes.problem_manager,
					version: kbRes.version,
					language: kbRes.language,
					version_date: kbRes.version_date,
					register_date: kbRes.register_date,
					summary: this.decodeSpecialEntitiesHtml(kbRes.summary),
					description: this.decodeSpecialEntitiesHtml(kbRes.description),
					points: kbRes.points,
					related_kb: [],
				};

				if (kbRes.relatedKb && kbRes.relatedKb.length > 0) {
					kbRes.relatedKb.forEach((relatedKb: any) => {
						const newRelatedKb: kbArchiveInterface = {
							id: relatedKb.id,
							summary: relatedKb.summary,
						};
						newKb.related_kb.push(newRelatedKb);
					});
				}

				return newKb;
			})
		);
	}

	evaluateKb(idKb: string, points: number): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const evaluateKbUrl = this.evaluateKbUrl.replace('{idKb}', idKb);
		return this.http.put(evaluateKbUrl, { points: points }, { headers: headers });
	}

	sendCommentary(idKb: string, commentary: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const postCommentaryKbUrl = this.postCommentaryKbUrl.replace('{idKb}', idKb);
		return this.http.post(postCommentaryKbUrl, { commentary: commentary }, { headers: headers });
	}

	decodeSpecialEntitiesHtml(htmlentities: string): string {
		const string_ = document.createElement('textarea');
		string_.innerHTML = htmlentities;
		string_.value = string_.value.replaceAll(String.raw`\n`, '<br />');
		return string_.value;
	}

	putRequestSolvedByKb(body: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.put(this.putRequestSolvedByKbUrl, body, { headers: headers });
	}
}
